import { useState, Profiler } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader as ReactStrapModalHeader,
} from "reactstrap";
import { useSelector } from "react-redux";
import Message from "../components/Message";

import BaseButton from "../baseComponents/baseButton";

import { getters as dictionaryGetters } from "../store/slices/dictionarySlice";

const AddModal = ({
  Component,
  ModalHeader = false,
  ModalContent = () => <></>,
  centered = true,
  modalCondition = true,
  hasFooter = true,
}) => {
  const [isModalOpened, setIsModalOpened] = useState(null);
  const [isModalFullyOpened, setIsModalFullyOpened] = useState(false);
  const [error, setError] = useState("");
  const isDictionaryLoaded = useSelector(dictionaryGetters.isDictionaryLoaded);
  const closeButtonLabel = isDictionaryLoaded ? "close" : "Zatvori";

  const openModal = () => {
    setIsModalOpened(true);
  };

  const closeModal = () => {
    setIsModalOpened(false);
  };

  const toogleModal = () => {
    setIsModalOpened((prevstate) => !prevstate);
  };

  //!props!
  const modalProps = {
    openModal,
    closeModal,
    toogleModal,
    isModalFullyOpened,
    setError,
  };
  

  return (
    <>
      {modalCondition && (
        <>
          <Modal
            centered={centered}
            toggle={() => closeModal()}
            isOpen={isModalOpened}
            onOpened={() => {
              setIsModalFullyOpened(true);
            }}
            onClosed={() => {
              setIsModalFullyOpened(false);
            }}
          >
            {ModalHeader && (
              <ReactStrapModalHeader>
                {ModalHeader(modalProps)}
              </ReactStrapModalHeader>
            )}
            <ModalBody>
              <>
                <div>{ModalContent(modalProps)}</div>
                {!hasFooter && <Message>{error}</Message>}
              </>
            </ModalBody>
            {hasFooter && (
              <ModalFooter>
                <BaseButton
                  translate={isDictionaryLoaded}
                  onClick={closeModal}
                  hasMarginTop={false}
                  error={error}
                >
                  {closeButtonLabel}
                </BaseButton>
              </ModalFooter>
            )}
          </Modal>
        </>
      )}
      {Component(modalProps)}
     
    </>
  );
};

export default AddModal;


 {/* <Profiler
        id="MyComponent"
        onRender={(id, phase, actualDuration) => {
          console.log(`Component ${id} ${phase} took ${actualDuration}ms`);
        }}
      >
         <Component modalProps = {modalProps}/>
        {Component(modalProps)}
      </Profiler> */}


            {/* <Profiler
        id="MyComponent2"
        onRender={(id, phase, actualDuration) => {
          console.log(`Component ${id} ${phase} took ${actualDuration}ms`);
        }}
      >
         <Component modalProps = {modalProps}/>
       
      </Profiler> */}
     